import { useIntl } from "react-intl";

import { useAnalyticsEvents } from "@atlaskit/analytics-next";
import CloudArrowUpIcon from "@atlaskit/icon/core/cloud-arrow-up";
import NoteIcon from "@atlaskit/icon/core/note";
import ShareIcon from "@atlaskit/icon/core/share";

import { useUserContext } from "@/components/user-context/user-context-provider";
import { Link } from "@/libraries/design/components/link/src/link";
import { ContentTypeImage } from "@/templates/home/home-page/src/sections-v2/jsm-xflow-hero/content-type-image.tsx";
import type {
    TabProps,
    TabType
} from "@/templates/home/home-page/src/sections-v2/jsm-xflow-hero/tab-type.tsx";
import { tabbedHeroSectionScreenshotsMessages } from "@/templates/home/home-page/src/sections-v2/reusable-xflow-hero-component/tabbed-hero-section.messages.tsx";

type ScreenshotsContentTypeProps = TabProps;

export const ScreenshotsContentType: TabType =
    ({}: ScreenshotsContentTypeProps) => {
        const intl = useIntl();
        const { createAnalyticsEvent } = useAnalyticsEvents();
        const { user } = useUserContext();

        return (
            <ContentTypeImage
                imageSrc="https://dam-cdn.atl.orangelogic.com/AssetLink/3y864mx2vd23i1eemvvv6q6524cg5p45.webp"
                imageAlt="This is an screenshot of a Loom screenshot and the popup that appear to annotate the screenshot with text."
                title={intl.formatMessage(
                    tabbedHeroSectionScreenshotsMessages.contentTitle
                )}
                description={intl.formatMessage(
                    tabbedHeroSectionScreenshotsMessages.contentDescription
                )}
                hideSeparator={true}
                iconCollection={[
                    {
                        description: intl.formatMessage(
                            tabbedHeroSectionScreenshotsMessages.contentFeaturePoint1
                        ),
                        icon: <NoteIcon label="" />
                    },
                    {
                        description: intl.formatMessage(
                            tabbedHeroSectionScreenshotsMessages.contentFeaturePoint2
                        ),
                        icon: <CloudArrowUpIcon label="" />
                    },
                    {
                        description: intl.formatMessage(
                            tabbedHeroSectionScreenshotsMessages.contentFeaturePoint3
                        ),
                        icon: <ShareIcon label="" />
                    }
                ]}
                cta={
                    <Link
                        href={"/software/loom"}
                        text={intl.formatMessage(
                            tabbedHeroSectionScreenshotsMessages.contentCta
                        )}
                        aria-label={intl.formatMessage(
                            tabbedHeroSectionScreenshotsMessages.contentCta
                        )}
                        type={"primary"}
                        dataEventProps={{
                            "data-product-key": "loom",
                            "data-event-component": "linkButton",
                            "data-event-container": "tabsMenu",
                            "data-event": "clicked",
                            "data-label": "try-it-out",
                            "data-label-english": "Explore Loom",
                            "data-track-event":
                                "loom-pt.content-types.video.cta"
                        }}
                        onClick={() => {
                            createAnalyticsEvent({
                                eventName: "loom-crossflow-tab-cta-clicked",
                                eventType: "ui",
                                action: "clicked",
                                actionSubject: "linkButton",
                                actionSubjectId: "loomCrossFlowHeroSection",
                                attributes: {
                                    reactComponent: "ScreenshotsContentType",
                                    tab: "screenshots",
                                    userTeamType:
                                        user.extended_profile?.team_type
                                }
                            }).fire();
                        }}
                    />
                }
                reverseLayout
            />
        );
    };
